<template>
  <div id="dashboard-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="175"
        aspect-ratio=1.5
        position="bottom 45% left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      ></v-img>
    </v-card>

    <v-card color="grey darken-4">
      <v-container fill-height fluid>
        <v-layout row align-center>
          <v-avatar
            size="50"
            class="display-2 font-weight-regular mr-2"
            color="urgent"
          >
            <v-icon color="secondary" large>mdi mdi-alert-circle-outline</v-icon>
          </v-avatar>
          <v-layout column justify-end>
            <!-- <div class="headline font-weight-light">{{userName}}</div> -->
            <div class="headline font-weight-light">Urgent</div>
            <!-- <div class="text-uppercase font-weight-light">{{userEmail}}</div> -->
            <div class="text-uppercase font-weight-light">Patent Disclosure</div>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card>

    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm6 md8>
          <v-card color="grey darken-4">
            <issue-tracker></issue-tracker>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <event-timeline></event-timeline>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <card-list/>
        </v-flex>
      </v-layout>

    </v-container>

  </div>
</template>

<script>
import CardList from './lists/CardList'
import Calendar from './widgets/Calendar'
import Timeline from './widgets/Timeline'
import IssueTracker from './widgets/IssueTracker'

export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1472235008642-bb3ce23994ac?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e3adf0e08574447e26d2c146f0fe9869&auto=format&fit=crop&w=1350&q=80'
    }
  },
  components: {
    'card-list': CardList,
    'event-calendar': Calendar,
    'event-timeline': Timeline,
    'issue-tracker': IssueTracker
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/dashboard/Dashboard.vue